<template>
  <MultipleChoicesDropdown
    title="Country"
    :value="startup.country"
    :show-clear-all="false"
    :single-choice="true"
    :search-enabled="true"
    :choices="countriesChoices"
    @change="onChange($event)"
  />
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: mapState({
    startup: (state) => state.startupProfile.startup,
    countriesChoices: (state) => state.startupProfile.countriesChoices,
  }),
  methods: {
    onChange(choice) {
      const attr = 'country'
      const value = choice.value
      if (this.startup[attr] !== value) {
        this.$store.commit('startupProfile/SET_STARTUP_ATTR', { attr, value })
      }
    },
  },
}
</script>
